import {useSelector} from "react-redux";
import {RootState} from "../reducers";


const useIsDemoMode = () => {
    const {user} = useSelector((store: RootState) => store.auth);
    return user && user.accessType === "client";
};

export default useIsDemoMode;
